import { ReactNode } from "react";
import { SystemInfoSubComponent } from "./system-info-sub-component";

interface BaseSubComponentProps {
  children?: ReactNode;
  uuid?: string;
  v1Id?: string | number | null;
  createdAt?: string;
  updatedAt?: string;
}

export function BaseSubComponent({ children, uuid, v1Id, createdAt, updatedAt }: BaseSubComponentProps) {
  return (
    <div className="bg-muted/30 space-y-4 p-4">
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {children}
        <SystemInfoSubComponent uuid={uuid} v1Id={v1Id} createdAt={createdAt} updatedAt={updatedAt} />
      </div>
    </div>
  );
}
